import React from 'react';
 import Carousal from "../../components/carousal/Carousal"
import workstyles from "./workstyles.module.css"
import basestyles from "../../styles/basestyles.module.css"


const AdayaWorks = () => {
    return (
        <div className={workstyles.carousalWrap}>
            <div className={basestyles.maxWidth}>
            <div className={workstyles.worksHeading}>
                <h1>How Adaya Works</h1>
            </div>
            <Carousal />
            </div>
        </div>
    );
}
 
 
export default AdayaWorks;